// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getPlatformObligationData} from "../../../ExternalData/Platform/PlatformClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationPlatformGrid() {

    // ****************** BEGIN STATES ****************************

    const [platformData, setPlatformData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    // ****************** BEGIN FETCH ****************************

    const fetchPlatformData = () =>
           getPlatformObligationData(767076)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setPlatformData(data);
                console.log("This is my data used for the grid rows...");
                console.log(platformData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My platform grid should have displayed...");
        fetchPlatformData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.platformGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({platformGridOpen: false}));
    };


    function closePlatformDataDrawer() {
        dispatchData(changeObligationHierarchy({platformGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchPlatformData => [

        {    field: 'externalId',
            headerName: 'External ID',
            description: '',
            sortable: false,
            width: 90,
            hide: false,
        },
        {    field: 'platformName',
            headerName: 'Name',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'service',
            headerName: 'Service',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'usageMarket',
            headerName: 'Market',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'territory',
            headerName: 'platformTerritory',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'owner',
            headerName: 'Owner',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>

                    <GridToolbarColumnsButton />
                    {/*<GridToolbarFilterButton sx={{mr: 3}} />*/}
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer sx={{height: "100%", width: 1000}}
                    anchor='right'
                    open={useSelector((state) => state.obligationHierarchySlc.value.platformGridOpen)}
                    onClose={closePlatformDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Platform Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro
                            style={{height: 600, width: 1000}}
                            aria-label={"PlatformDataDrawerGrid"}
                            rows={platformData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}
                            columns={columns(fetchPlatformData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            rowThreshold={0}
                            components={{
                                Toolbar: CustomToolbar,
                            }}

                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************


}



